import { useRef, useEffect, useState, MutableRefObject } from 'react';

interface DimensionsInterface {
  /**
   * The element width.
   */
  width: string | number;
  /**
   * The element height.
   */
  height: string | number;
}

type UseDimensionsReturnType = [MutableRefObject<any>, DimensionsInterface];

/**
 * The hook that calculates referenced element's dimensions.
 *
 * @param {DimensionsInterface} initialDimensions
 *  The initial dimensions.
 * @returns {UseDimensionsReturnType}
 *  Current ref and dimensions as an array.
 */
export const useDimensions = (
  initialDimensions: DimensionsInterface = { height: 720, width: '100%' },
): UseDimensionsReturnType => {
  const ref = useRef(null),
    [dimensions, setDimensions] = useState<DimensionsInterface>(
      initialDimensions,
    );

  useEffect(() => {
    ref.current && setDimensions((ref.current as any).getBoundingClientRect());
  }, []);

  return [ref, dimensions];
};
